class LastInputTabManager {
    constructor() {
        this._init()
    }
    _init() {
        this.els = document.querySelectorAll('[data-last-input]')
        if(this.els.length == 0) {
            return
        }
        this.els.forEach(el => {
            el.lastInput = new LastInputTab(el, this)
        })
    }
}

class LastInputTab {
    constructor(el, manager) {
        this._init(el, manager)
    }
    _init(el, manager) {
        this.el = el
        this.manager = manager
        this.id = this.el.getAttribute('data-last-input')
        this.next = document.querySelector('[data-last-input-action="' + this.id + '"]')
        
        this.el.onblur = () => setTimeout(() => this.onBlur(), 1)
        this.newNext = document.querySelector('[data-last-input-new="' + this.id + '"]')
    }
    onBlur() {
        if(!this.next || document.activeElement == this.next) {
            if(this.next) {
                this.next.blur()
            }
            this.newNext.click()
            // if(this.newNext){
            //     this.newNext.focus()
            // }
        }
    }
}

export default LastInputTabManager